import React from "react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { COLORS } from "../constants/constants";
interface HeroProps {
  handleOpenBooking: (serviceId: string) => void;
}

const Hero: React.FC<HeroProps> = (props) => {
  return (
    <section id="hero" className="relative">
      <Box className="relative bg-blue-50 w-full h-[220px] lg:h-auto aspect-[3.5] bg-fill lg:bg-cover bg-center flex flex-row justify-center items-center">
        {/* Mobile Image */}
        <img
          src="/images/hero_mobile.png"
          alt="Hero Mobile"
          className="absolute top-0 left-0 w-full h-full object-cover lg:hidden"
        />

        {/* Desktop Image */}
        <img
          src="/images/hero.png"
          alt="Hero Desktop"
          className="absolute top-0 left-0 w-full h-full object-cover hidden lg:block"
        />
        <Container maxWidth="lg" className="relative h-2/3 !z-10 ">
          <Grid className="h-full">
            <div className=" w-[80%] lg:w-1/2 text-left">
              <Typography className="pl-2 hidden lg:block  text-gray-600  !font-medium">
                Chất lượng cao với giá cả phải chăng.
              </Typography>
              <Box className="relative rounded-lg shadow-md lg:shadow-none">
                <div className="lg:hidden absolute inset-0 bg-white  opacity-70 rounded-lg shadow-md"></div>
                <div className="relative z-10">
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "16px",
                        lg: "34px",
                      },
                    }}
                    className=" pl-2 pb-2  text-gray-600  !font-black"
                  >
                    Dịch vụ máy lạnh chuyên nghiệp, hiệu quả, chất lượng
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "13px",
                        lg: "20px",
                      },
                    }}
                    className=" pb-3 pl-2   !font-thin text-gray-600"
                  >
                    Chúng tôi cung cấp các dịch vụ liên quan đến máy lạnh với
                    chi phí và thời gian thấp nhất, chất lượng cao nhất.
                  </Typography>
                </div>
              </Box>
              <Box className="pl-2 flex gap-4 pt-2 lg:pt-0">
                <Button
                  className=" lg:!text-base !bg-primary_blue !text-white !px-3 lg:!px-4 lg:!py-"
                  variant="contained"
                  color="success"
                  onClick={() => props.handleOpenBooking("")}
                  sx={{
                    color: "#4D4D4D",
                    textTransform: "none",
                    backgroundColor: COLORS.primary_blue,
                    "&:hover": {
                      color: COLORS.primary_blue,
                    },
                  }}
                >
                  Đặt lịch ngay
                </Button>
                <Button
                  className=" lg:!text-base !bg-slate-100 lg:!bg-transparent !px-4 !py-2"
                  variant="contained"
                  color="success"
                  href="#services"
                  sx={{
                    color: "#4D4D4D",
                    textTransform: "none",
                    backgroundColor: COLORS.primary_blue,
                    "&:hover": {
                      color: COLORS.primary_blue,
                    },
                  }}
                >
                  Tất cả dich vụ
                </Button>
              </Box>
            </div>
          </Grid>
        </Container>
      </Box>
    </section>
  );
};

export default Hero;
